import { render, staticRenderFns } from "./MenuCategory.vue?vue&type=template&id=7c0d5801&scoped=true"
import script from "./MenuCategory.vue?vue&type=script&lang=ts"
export * from "./MenuCategory.vue?vue&type=script&lang=ts"
import style0 from "./MenuCategory.vue?vue&type=style&index=0&id=7c0d5801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d5801",
  null
  
)

export default component.exports